"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreConnectivityService = void 0;
const lodash_1 = __importDefault(require("lodash"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class FirestoreConnectivityService {
    constructor(random) {
        this.random = random;
        this.requestReconnectCount = new rxjs_1.BehaviorSubject(0);
        this.currentReconnecting = new rxjs_1.BehaviorSubject({});
    }
    reconnect() {
        this.requestReconnectCount.next(this.requestReconnectCount.value + 1);
    }
    isReconnectingStream() {
        return this.currentReconnecting.asObservable().pipe((0, operators_1.map)((dict) => lodash_1.default.size(dict) > 0), (0, operators_1.distinctUntilChanged)(lodash_1.default.isEqual));
    }
    /** only emits when the state changed from reconnecting to reconnected */
    isReconnectedStream() {
        return this.isReconnectingStream().pipe((0, operators_1.pairwise)(), (0, operators_1.map)(([previous, current]) => !previous && current), (0, operators_1.filter)((value) => value === true));
    }
    /** only emits when reconnect has been requested */
    reconnectRequestedStream() {
        return this.requestReconnectCount.asObservable().pipe((0, operators_1.skip)(1), // skip one because the count is a var that emites its last result when subscribed, we only want new emits
        (0, operators_1.map)(() => new Date()));
    }
    registerReconnection(id) {
        const val = this.currentReconnecting.value;
        val[id] = true;
        this.currentReconnecting.next(val);
    }
    removeRegistration(id) {
        const val = this.currentReconnecting.value;
        delete val[id];
        this.currentReconnecting.next(val);
    }
    /**x
     * creates a new stream where the generator will be called within a switchmap whenever a reconnection is requested
     */
    withReconnectionStream(generator) {
        return rxjs_1.Observable.create((observer) => {
            const reconnectId = this.random();
            const stopRetryingTrigger = new rxjs_1.Subject();
            // map elke reconnect request naar een stream van pogingen (3 in 15 seconden, totdat we data krijgen)
            const reconnectTriggers = this.reconnectRequestedStream().pipe(
            // een stream die na 1 seconden een timer start om de 5 seconden
            (0, operators_1.switchMap)(() => (0, rxjs_1.timer)(1000, 5000, rxjs_1.asapScheduler).pipe((0, operators_1.takeUntil)(stopRetryingTrigger.asObservable()), // stop als we data binnen krijgen
            (0, operators_1.take)(3), // max 3 pogingen
            (0, operators_1.tap)((i) => {
                console.info(`Reconnect to stream attempt #${i + 1}`);
                this.registerReconnection(reconnectId);
            }))));
            const triggers = (0, rxjs_1.concat)((0, rxjs_1.of)(Date.now()), // on a new subscription, we always want to start with an initial emit
            reconnectTriggers // after that we listen to newly requested reconnects
            );
            const subscription = triggers.pipe((0, operators_1.switchMap)(() => generator())).subscribe((value) => {
                stopRetryingTrigger.next(true);
                this.removeRegistration(reconnectId);
                observer.next(value);
            }, (error) => {
                this.removeRegistration(reconnectId);
                observer.error(error);
            }, () => {
                this.removeRegistration(reconnectId);
                observer.complete();
            });
            // unsubscribe function
            return () => {
                this.removeRegistration(reconnectId);
                subscription.unsubscribe();
            };
        });
    }
}
exports.FirestoreConnectivityService = FirestoreConnectivityService;
//# sourceMappingURL=FirestoreConnectivityService.js.map